module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/location.svg?4f149c7e";